import config from "./appConfig.json";
export const URL = config.serverUrl;
export const unilever = "unilever";
export const cibc = "cibc";
export const production = "do-prod.accdevcluster";
export const staging = "staging.aocc-staging";
export const local = "localhost";
export const development = "development.aocc-staging";